define.alias("shared/components/shared/social/refresh-profile/pinterest", "media/components/shared/social/refresh-profile/pinterest");